<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />

  <p-card>
    <ng-template #title>
      <h1>
        {{
          isEditMode()
            ? ('catalog.openingHourTypes.edit' | translate)
            : ('catalog.openingHourTypes.add' | translate)
        }}
      </h1>
    </ng-template>

    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-4"
    >
      <div class="flex flex-col">
        <label for="oht-name" class="text-sm mb-1">
          {{ 'catalog.openingHourTypes.fields.name' | translate }}
        </label>
        <input
          id="oht-name"
          pInputText
          formControlName="name"
          [maxlength]="255"
        />
        @if (form.get('name')?.touched && form.get('name')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex items-center gap-3">
        <p-toggleswitch inputId="oht-public" formControlName="public" />
        <label for="oht-public" class="text-sm">
          {{ 'catalog.openingHourTypes.fields.public' | translate }}
        </label>
      </div>

      <div class="flex justify-between items-center pt-2">
        <p-button
          type="button"
          severity="secondary"
          [label]="'label.cancel' | translate"
          (onClick)="onCancel()"
        />
        <div class="flex gap-2">
          @if (isEditMode() && model()) {
            <p-button
              type="button"
              severity="danger"
              icon="fa fa-trash"
              [label]="'label.delete' | translate"
              (onClick)="onDelete($event)"
            />
          }
          <p-button
            type="submit"
            [label]="'label.save' | translate"
            [loading]="submitting()"
          />
        </div>
      </div>
    </form>
  </p-card>

  @if (isEditMode() && ownerId() !== null) {
    <p-card>
      <app-opening-hour-row-table
        [typeId]="ownerId()!"
        [hours]="hours()"
        (changed)="reload()"
      />
    </p-card>
  }
</div>
